import React from 'react';
import { Row, Col, Form } from "react-bootstrap";
import "../../sass/main.scss";
import './FormField.scss';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core';
import { INVALID_DATE } from '../constants/ApiConstants';
import { mirrorData } from '../../common/utils/appUtils'

export interface DateFieldProps {
    label?: string,
    placeholder: string,
    required?: boolean,
    maxDate?: Date,
    minDate?: Date,
    errMsg: string,
    onChange: (value?: Date | string) => void,
    value?: Date | string,
    showError?: boolean,
    disabled?: boolean,
    className?: string,
    name?: string,
    onBlur?: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
    onChangeVal?: (value?: Date, name?: string) => void,
    onChangeRTRDateRange?: (name: string | undefined, value: string) => void,
    onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void,
    labelSameLine?: boolean
}

function DateField(props: DateFieldProps) {

    const {
        label,
        name,
        placeholder,
        required,
        maxDate,
        minDate,
        errMsg = "",
        onChange,
        value,
        onKeyDown
    } = props


    const useStyle = makeStyles(theme => ({
        root: {
            '& .MuiInput-root': {
                border: "1px solid #CC5967 !important"
            }
        }

    }))


    const classes = useStyle()

    const onChangeDate = (date?: Date) => {
        props.onChangeVal?.(date, props.name);

        if (date == undefined) {
            onChange(undefined)
        } else if (!isNaN(date.getTime())) {
            onChange(date)
            props.onChangeRTRDateRange?.(props.name, date.toISOString())
            mirrorData(name ?? "", date)
        }
    }

    const onBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (e.target.value === ""){
            onChange(undefined);
            return;
        }
        let date = new Date(e.target.value)

        if (isNaN(date.valueOf())) {
            onChange(INVALID_DATE)
        } else if (props.onBlur) {
            props.onBlur(e);
        } else if (name) {
            let patientMinDOB = new Date();
            patientMinDOB.setFullYear(patientMinDOB.getFullYear() - 120);
            let futureDate = new Date();
            if (date.getTime() > futureDate.getTime()) {
            } else if (date.getTime() < patientMinDOB.getTime()) {
            } else if (date && !isNaN(date.getTime())) {
                mirrorData(name, date)
            } else {
                mirrorData(name, null)
            }
        }
    }

    const onKeyup = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "T" || e.key === "t") {
            var d = new Date();
            d.setHours(0);
            d.setMinutes(0);
            d.setSeconds(0);
            d.setMilliseconds(0);
            onChangeDate(d);
        }
    }

    const labelBlock = () => {
        return <Form.Label >{label}{required ?
            <span className="required" style={{ color: "red" }}>*</span> : null}</Form.Label>
    }

    const pickerBlock = () => {
        return (<>
                {errMsg.length > 0 ? <span className="alert-icon  alert-icon-align"></span> : ''}
                <MuiPickersUtilsProvider utils={DateFnsUtils}  >
                    <KeyboardDatePicker
                        className={errMsg.length > 0 ? classes.root : props.disabled ? 'date-field-disable date-field-style' : 'date-field-style'}
                        onBlur={onBlur}
                        fullWidth
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        value={value && value.toString() != INVALID_DATE ? value : null}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        allowKeyboardControl={true}
                        autoOk={true}
                        maxDate={maxDate}
                        minDate={minDate}
                        placeholder={placeholder}
                        {...(errMsg && { error: true, helperText: errMsg })}
                        type="text"
                        onChange={date => onChangeDate(date ?? undefined)}
                        onKeyUp={key => onKeyup(key)}
                        onKeyDown={e => onKeyDown && onKeyDown(e)}
                        disabled={props.disabled}
                    />
                </MuiPickersUtilsProvider>
            </>)
    }

    const errorBlock = () => {
        return (<span className="error-message">{props.errMsg}</span>)
    }

    const labelSameLine = () => {
        return (<Form className={`date-field-input ${props.className}`} onSubmit={e => { e.preventDefault(); }}>
            <Row>
                <Col>{label ? 
                 labelBlock() 
             : null}
                { pickerBlock() }
                </Col>
            </Row>
            {props.errMsg.length > 0 ?
                <Row>
                    <Col>{ errorBlock() }</Col>
                </Row> : null}
        </Form>)
    }

    const labelSeparateLine = () => {
        return (<Form className={`date-field-input ${props.className}`} onSubmit={e => { e.preventDefault(); }}>
            {label ? <Row>
                <Col>{ labelBlock() }</Col>
            </Row> : null}
            <Row>
                <Col>{ pickerBlock() }</Col>
            </Row>
            {props.errMsg.length > 0 ?
                <Row>
                    <Col >{ errorBlock() }</Col>
                </Row> : null}
        </Form>)
    }

    return (
        props.labelSameLine ? labelSameLine() : labelSeparateLine()
    )
}

export default DateField;
